import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'AreaDoCliente',
      storage,
      whitelist: ['auth', 'user', 'properties', 'property'],
    },
    reducers
  );

  return persistedReducer;
};
